import { useEffect } from "react";
import { useApiError } from "./useApiError";

export const useReportQueryError = (error: unknown) => {
  const { triggerSoft } = useApiError();
  useEffect(() => {
    if (error) triggerSoft(error);
  }, [error, triggerSoft]);
};
